/*
 *
 * Copyright © Tessell Inc, 2021. All rights reserved.
 *
 *     Date            Author                  Comment
 *   --------------------------------------------------
 *     8/19/2021     bakul.banthia         Created
 *
 */
import clsx from 'clsx';
import React from 'react';
import { useStyles } from './utils';

export default function AmexCardIcon(props) {
    const { className } = props;
    const iconStyle = useStyles(props);

    return (
        <svg
            className={clsx({ [className]: !!className })}
            style={iconStyle}
            viewBox="0 0 50 50"
            width="39"
            height="39"
            xmlSpace="preserve"
            fill="none"
            // xversion="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g clipPath="url(#a)">
                <path
                    d="M.002.044h43.889v23.693l-2.173 3.394 2.173 3.02v13.782H.002V21.598l1.358-1.561-1.358-1.494V.044Z"
                    fill="#016FD0"
                />
                <path
                    d="M8.521 30.627v-6.89h7.296l.782 1.02.81-1.02h26.48v6.415s-.692.468-1.493.475H27.733l-.883-1.086v1.086h-2.892v-1.854s-.395.259-1.249.259h-.984v1.595h-4.379l-.781-1.043-.794 1.043h-7.25ZM.002 18.543l1.645-3.835h2.845l.934 2.148v-2.149h3.537l.556 1.553.539-1.553h15.877v.781s.834-.78 2.206-.78l5.151.018.918 2.12v-2.139h2.96l.814 1.218v-1.218h2.987v6.891h-2.986l-.781-1.222v1.222h-4.349l-.437-1.086h-1.17l-.43 1.086H27.87c-1.18 0-1.934-.765-1.934-.765v.765h-4.447l-.883-1.086v1.086H4.072l-.437-1.086H2.469l-.434 1.086H.002v-3.055Z"
                    fill="#fff"
                />
                <path
                    d="m2.23 15.557-2.22 5.16h1.445l.41-1.034h2.38l.407 1.033h1.477l-2.217-5.16H2.229Zm.82 1.2.726 1.806H2.323l.727-1.805Zm3.23 3.958v-5.159l2.054.008 1.194 3.326 1.165-3.334h2.037v5.16h-1.29v-3.802l-1.367 3.801H8.942L7.57 16.914v3.801H6.28Zm7.333 0v-5.159h4.209v1.154h-2.906v.883h2.838v1.086h-2.838v.916h2.906v1.12h-4.21Zm4.956-5.158v5.16h1.29v-1.834h.543l1.546 1.833h1.577l-1.698-1.9a1.571 1.571 0 0 0 1.415-1.585c0-1.086-.852-1.674-1.803-1.674h-2.87Zm1.29 1.154h1.474c.354 0 .611.277.611.543 0 .343-.333.543-.592.543H19.86v-1.086Zm5.227 4.004h-1.317v-5.159h1.317v5.16Zm3.122 0h-.284c-1.375 0-2.21-1.083-2.21-2.558 0-1.511.825-2.6 2.562-2.6h1.426v1.221h-1.478c-.705 0-1.204.55-1.204 1.392 0 .999.57 1.419 1.392 1.419h.34l-.544 1.127Zm2.807-5.158-2.22 5.16h1.446l.409-1.034h2.38l.408 1.033h1.476l-2.217-5.16h-1.682Zm.82 1.2.727 1.806h-1.454l.728-1.805Zm3.23 3.958v-5.159h1.64l2.094 3.242v-3.242h1.29v5.16h-1.587l-2.147-3.327v3.326h-1.29ZM9.404 29.744v-5.159h4.209v1.154h-2.906v.883h2.838v1.086h-2.838v.916h2.906v1.12h-4.21Zm20.624 0v-5.159h4.209v1.154H31.33v.883h2.824v1.086H31.33v.916h2.906v1.12h-4.21Zm-16.252 0 2.05-2.547-2.099-2.612h1.626l1.25 1.614 1.253-1.614h1.561l-2.07 2.58 2.053 2.58h-1.625l-1.213-1.59-1.184 1.59h-1.602Zm5.777-5.158v5.16h1.323v-1.63h1.358c1.15 0 2.02-.61 2.02-1.795 0-.982-.683-1.735-1.852-1.735h-2.85Zm1.323 1.167h1.43c.371 0 .637.227.637.594 0 .344-.264.594-.64.594h-1.427v-1.188Zm3.938-1.168v5.16h1.29V27.91h.543l1.546 1.833h1.577l-1.697-1.9a1.571 1.571 0 0 0 1.415-1.585c0-1.086-.853-1.674-1.804-1.674h-2.87Zm1.29 1.154h1.474c.354 0 .611.277.611.543 0 .343-.333.543-.592.543h-1.493V25.74Zm8.73 4.005v-1.12h2.582c.382 0 .547-.206.547-.433 0-.216-.165-.436-.547-.436h-1.167c-1.014 0-1.579-.617-1.579-1.545 0-.827.517-1.625 2.024-1.625h2.512l-.543 1.16h-2.172c-.416 0-.544.219-.544.427 0 .214.158.45.476.45h1.222c1.13 0 1.62.64 1.62 1.48 0 .903-.546 1.642-1.682 1.642h-2.749Zm4.734 0v-1.12h2.582c.381 0 .547-.206.547-.433 0-.216-.165-.436-.547-.436h-1.167c-1.014 0-1.579-.617-1.579-1.545 0-.827.517-1.625 2.024-1.625h2.512l-.543 1.16h-2.172c-.416 0-.544.219-.544.427 0 .214.158.45.476.45h1.222c1.13 0 1.62.64 1.62 1.48 0 .903-.546 1.642-1.682 1.642h-2.749Z"
                    fill="#016FD0"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" transform="translate(.002)" d="M0 0h43.998v43.998H0z" />
                </clipPath>
            </defs>
            <rect x=".5" y=".5" width="44" height="44" stroke="#D2D2D2" />
        </svg>
    );
}
